/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 3/18/2017
 * Copyright All Rights Reserved
 */

import {
  REQUEST_TOKEN,
  REQUEST_TOKEN_SUCCESS,
  REQUEST_TOKEN_FAILURE,
  DESTROY_TOKEN,
} from 'constants/actionTypes';

const initialState = {
  isBeingFetched: false,
  errorMessage: '',
  value: '',
  user: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_TOKEN:
      return Object.assign({}, state, { isBeingFetched: true, errorMessage: '' });
    case REQUEST_TOKEN_SUCCESS:
      return Object.assign({}, state, {
        isBeingFetched: false,
        value: action.token,
        user: action.userId,
      });
    case REQUEST_TOKEN_FAILURE:
      return Object.assign(
        {},
        state,
        {
          errorMessage:
            (action.error.response && action.error.response.status === 401)
            ? 'Invalid Email or Password'
            : 'There was a problem with your request',
          isBeingFetched: false,
        });
    case DESTROY_TOKEN:
      return Object.assign({}, state, { value: '' });
    default:
      return state;
  }
};
